import api from './api';

export const CreateApp = (developer_id, data) => api.post(`console/${developer_id}/apps_create`, data).then(res => res.data);
export const GetApp = (developer_id, app_id) => api.get(`console/${developer_id}/app/${app_id}`).then(res => res.data);
export const UpdateApp = (developer_id, app_id, data) => api.put(`console/${developer_id}/app/${app_id}`, data).then(res => res.data);
export const DeleteApp = (developer_id, app_id) => api.delete(`console/${developer_id}/app/${app_id}`).then(res => res.data);